<div class="layout-wrapper h-screen w-screen" [ngClass]="containerClass()">
  <div class="bg-orange-500" app-sidebar></div>
  <div class="layout-content-wrapper">
    <div class="layout-content-wrapper-inside">
      <!--<div app-topbar></div>-->
      <div class="layout-content">
        <p-toast class="shrink-0"></p-toast>
        <p-confirmDialog #cd [style]="{ width: '450px' }" />
        <div app-breadcrumb></div>
        <router-outlet (activate)="onComponentActivate($event)"></router-outlet>
      </div>
      <!--<div app-footer></div>-->
    </div>
  </div>
  <app-layout-configurator />
  <div app-search></div>
  <div app-rightmenu></div>
  <div class="layout-mask animate-fadein"></div>
</div>

<!--<div class="flex flex-row w-full" style="height: 100%;">
  <div class="bg-orange-500" style="height: 100%;">
    <app-sidebar />
  </div>
  <div class="w-full flex flex-col">

    <p-toast></p-toast>
    <router-outlet class="bg-red-100"></router-outlet>
  </div>
</div>-->